import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import AddCategory from "../../core/modals/inventory/addcategory";
import {
  getTypeOfOffers,
  getFormOfOffers,
  createFormOfOffer,
  createTypeOfOffer,
  getPaymentDetails,
  createPaymentDetail,
  // getCallCenters,
  // getPhoneNumbers,
  createOffer,
  updateOffer,
  getNextOfferNumber,
} from "../../core/api/marketing";
import {
  getConfirmedProductVariationsByProductId,
  getProductVariationsByProductBrand,
  getProductsByBrand,
} from "../../core/api/products";
import AddTwoFieldsModal from "../../core/modals/inventory/addCategoryWithTwoValues";
import {
  fetchPhoneNumbersByCallCenter,
  getAllStatus,
  getClient,
  updatePhoneNumberOffer,
} from "../../core/api/settings";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { setSelectedClients } from "../../core/redux/action";
import IndependentSKU from "./independentSKU";
import MarketingFilesSection from "./marketingfilessection";
import { getMarketingSKUsByBrand, getOfferById } from "../../core/api/marketing";
import MarketingSKUTable from "./components/editMarketing/MarketingSKUTable";
import OfferCodificationSection from "./components/editMarketing/OfferCodificationSection";
import OfferSpecification from "./components/editMarketing/OfferSpecification";
import OfferStatusSection from "./components/editMarketing/OfferStatusSection";
const EditMarketing = ({ id, isEditMode = false, cId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const marketingFileRef = useRef();
  const selectedClients = useSelector((state) => state.selectedClients);
  const { id: urlId } = useParams();
  const [clientId, setClientId] = useState(id ? cId : selectedClients[0]);
  const location = useLocation();
  const parts = location.pathname.split("/"); // ['', 'marketing', 'edit-marketing', '2']
  const urlMarketingId = parts[3]; // index 3 contains the ID
  const [marketingId, setMarketingId] = useState(Number(urlMarketingId));
  const [typeOfOffer, setTypeOfOffer] = useState(null);
  const [formOfOffer, setFormOfOffer] = useState(null);
  const [codeOffer, setCodeOffer] = useState("");
  const [paymentDetail, setPaymentDetail] = useState(null);
  const [payeeName, setPayeeName] = useState(null);
  const [callCenter, setCallCenter] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [warranty, setWarranty] = useState(0);
  const [giftVisible, setGiftVisible] = useState("No");
  const [returnAddress, setReturnAddress] = useState(null);
  const [products, setProducts] = useState([]);
  const [productVariations, setProductVariations] = useState([]);
  const [statuts, setStatuts] = useState([]);
  const [typeOfOffers, setTypeOfOffers] = useState([]);
  const [formOfOffers, setFormOfOffers] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [existingMarketingData, setExistingMarketingData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [offer_status_description, setOfferStatusDescription] = useState("");
  const MySwal = withReactContent(Swal);
  const [offerPricingsOptions, setOfferPricingOptions] = useState([]);
  const [allProductVariations, setAllProductVariations] = useState([]);
  const [callCenters, setCallCenters] = useState([]);
  const [phoneNumbers, setPhonenumbers] = useState([]);
  const [clientBrands, setClientBrands] = useState([]);
  const [clientReturnAddresses, setClientReturnAddresses] = useState([]);
  const [clientPayeeNames, setClientPayeeNames] = useState([]);
  const [selectedParcelInsertVariations, setSelectedParcelInsertVariations] = useState([]);

  // useEffect(() => {
  //   console.log("Client: ", selectedClients);
  //   console.log("id: ", id);
  //   console.log("cid: ", cId);
  // }, []);

  useEffect(() => {
    const fetchDropdownData = async () => {
      if (clientId) dispatch(setSelectedClients([clientId]));
      if (!clientId) return;
      const clientData = await getClient(clientId);
      setClientBrands(
        clientData.data.brands.map((br) => ({
          value: br.id,
          label: br.brand_name,
          object: br,
        }))
      );

      try {
        console.log("getting the status, brand offers ...");
        const [
          statusRes,
          typeOfOffersRes,
          formOfOffersRes,
          paymentDetailsRes,
          // callCentersRes,
          // phoneNumbersRes,
        ] = await Promise.all([
          getAllStatus(),
          getTypeOfOffers(),
          getFormOfOffers(),
          getPaymentDetails(),
          // getCallCenters(),
          // getPhoneNumbers(),
        ]);
        console.log("data got: ", {
          status: statusRes,
          typeOfOffers: typeOfOffersRes,
          formOfOffers: formOfOffersRes,
          paymentDetails: paymentDetailsRes,
          // callCenters: callCentersRes,
          // phoneNumbers: phoneNumbersRes,
        });
        setStatuts(statusRes.data.map((s) => ({ value: s.id, label: s.name })));
        setTypeOfOffers(
          typeOfOffersRes.data.map((t) => ({
            value: t.id,
            label: t.type_of_offer,
            code: t.type_code,
          }))
        );
        setFormOfOffers(
          formOfOffersRes.data.map((f) => ({
            value: f.id,
            label: f.form_of_offer,
            code: f.form_code,
          }))
        );

        setPaymentDetails(paymentDetailsRes.data.map((d) => ({ value: d.id, label: d.detail })));
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };
    if (clientId) fetchDropdownData();
  }, [clientId, isEditMode, dispatch]);

  const fetchMarketingSKUsByBrand = async () => {
    if (selectedBrand) {
      const response = await getMarketingSKUsByBrand(selectedBrand.object.id);
      setOfferPricingOptions(
        response.data.results.map((pricing) => ({
          value: pricing.id,
          label: pricing.sku,
          object: pricing,
          pId: null,
        }))
      );
    }
  };

  useEffect(() => {
    if (selectedBrand) {
      fetchMarketingSKUsByBrand();
    }
  }, [selectedBrand]);

  useEffect(() => {
    setMarketingId(urlMarketingId);
    // Clear all state when there's no ID in the URL
    if (!urlMarketingId) {
      setExistingMarketingData(null);
      setTypeOfOffer(null);
      setFormOfOffer(null);
      setCodeOffer("");
      setPaymentDetail(null);
      setPayeeName(null);
      setCallCenter(null);
      setPhoneNumber(null);
      setWarranty(0);
      setGiftVisible("No");
      setReturnAddress(null);
      setProducts([]);
      setProductVariations([]);
      setSelectedProduct(null);
      setSelectedVariation(null);
      setSelectedStatus(null);
      setOfferStatusDescription("");
      setSelectedBrand(null);
      setOfferPricingOptions([]);
      setSelectedParcelInsertVariations([]);
      setPhonenumbers([]);
      setClientReturnAddresses([]);
      setClientPayeeNames([]);
      setSelectedOfferPricings([]);
      return;
    }

    // Only fetch marketing data if we have an ID
    fetchMarketingData();
  }, [urlMarketingId]);

  useEffect(() => {
    if (selectedBrand && isEditMode && existingMarketingData) {
      const { return_address, payee_names } = selectedBrand.object;

      const validReturnAddresses =
        return_address?.map((addr) => ({
          value: addr,
          label: addr,
        })) || [];
      const validPayeeNames =
        payee_names?.map((name) => ({
          value: name,
          label: name,
        })) || [];

      setClientReturnAddresses(validReturnAddresses);
      setClientPayeeNames(validPayeeNames);

      setReturnAddress(
        validReturnAddresses.find((addr) => addr.value === existingMarketingData.return_address) ||
          null
      );
      setPayeeName(
        validPayeeNames.find((name) => name.value === existingMarketingData.payee_name) || null
      );
    }
  }, [selectedBrand, isEditMode, existingMarketingData]);

  useEffect(() => {
    if (marketingId && statuts.length && typeOfOffers.length && formOfOffers.length) {
      fetchMarketingData();
    } else if (!marketingId) {
      // Clear all state when there's no ID
      setExistingMarketingData(null);
      setTypeOfOffer(null);
      setFormOfOffer(null);
      setCodeOffer("");
      setPaymentDetail(null);
      setPayeeName(null);
      setCallCenter(null);
      setPhoneNumber(null);
      setWarranty(0);
      setGiftVisible("No");
      setReturnAddress(null);
      setProducts([]);
      setProductVariations([]);
      setSelectedProduct(null);
      setSelectedVariation(null);
      setSelectedStatus(null);
      setOfferStatusDescription("");
      setSelectedOfferPricings([]);
    }
  }, [marketingId, statuts, typeOfOffers, formOfOffers, id, clientBrands]);

  const fetchMarketingData = async () => {
    try {
      if (!marketingId) return;

      // Clear previous data before fetching new data
      setExistingMarketingData(null);
      setTypeOfOffer(null);
      setFormOfOffer(null);
      setCodeOffer("");
      setPaymentDetail(null);
      setPayeeName(null);
      setCallCenter(null);
      setPhoneNumber(null);
      setWarranty(0);
      setGiftVisible("No");
      setReturnAddress(null);
      setProducts([]);
      setProductVariations([]);
      setSelectedProduct(null);
      setSelectedVariation(null);
      setSelectedStatus(null);
      setOfferStatusDescription("");

      const response = await getOfferById(marketingId);
      const data = response.data;

      setExistingMarketingData(data);
      setOfferStatusDescription(data.offer_description || "");
      setSelectedStatus(statuts.find((s) => s.value === data.status?.id) || null);
      setCodeOffer(data.code_offer || "");
      setWarranty(data.warranty || 0);
      setGiftVisible(data.gift_visible_in_offer || "No");

      setTypeOfOffer(typeOfOffers.find((t) => t.value === data.type_of_offer?.id) || null);
      setFormOfOffer(formOfOffers.find((f) => f.value === data.form_of_offer?.id) || null);

      setPaymentDetail(paymentDetails.find((d) => d.value === data.payment_details?.id) || null);

      const selectedBrand = clientBrands.find((b) => b.value === data.brand) || null;
      setSelectedBrand(selectedBrand);

      if (selectedBrand) {
        const { return_address, payee_names, call_centers } = selectedBrand.object;

        const validReturnAddresses =
          return_address?.map((addr) => ({ value: addr, label: addr })) || [];
        const validPayeeNames = payee_names?.map((name) => ({ value: name, label: name })) || [];

        setClientReturnAddresses(validReturnAddresses);
        setClientPayeeNames(validPayeeNames);

        const selectedPayeeName =
          validPayeeNames.find((name) => name.value === data.payee_name) || null;
        const selectedReturnAddress =
          validReturnAddresses.find((addr) => addr.value === data.return_address) || null;

        setPayeeName(selectedPayeeName);
        setReturnAddress(selectedReturnAddress);

        const validCallCenters =
          call_centers?.map((center) => ({
            value: center.id,
            label: center.name,
            object: center,
          })) || [];
        setCallCenters(validCallCenters);

        const selectedCallCenter =
          validCallCenters.find(
            (center) => center.value === data.phone_number_details?.call_center
          ) || null;
        setCallCenter(selectedCallCenter);

        if (selectedCallCenter) {
          const phoneNumbersRes = await fetchPhoneNumbersByCallCenter(selectedCallCenter.value);
          const validPhoneNumbers = phoneNumbersRes.data
            .filter(
              (p) =>
                p.status === "Available" ||
                p.status === codeOffer ||
                (data.phone_number_details && p.id === data.phone_number_details.id)
            )
            .map((p) => ({
              value: p.id,
              label: `${p.phone_number} - ${p.status}`,
            }));

          setPhonenumbers(validPhoneNumbers);

          const selectedPhoneNumber =
            validPhoneNumbers.find((p) => p.value === data.phone_number_details?.id) || null;

          setPhoneNumber(selectedPhoneNumber);
        }
      }

      if (data.brand) {
        const productsRes = await getProductsByBrand(data.brand);
        const productsList = productsRes.data.map((p) => ({
          value: p.id,
          label: p.name,
          object: p,
        }));
        setProducts(productsList);

        if (data.type_of_offer?.type_of_offer === "Mailing") {
          const product = productsList.find(
            (p) => p.value === data.product_variations_detail[0]?.product_id
          );
          setSelectedProduct(product || null);

          if (product) {
            const variationsRes = await getConfirmedProductVariationsByProductId(product.value);
            const variations = variationsRes.data.map((v) => ({
              value: v.id,
              label: v.product_variation_desc,
            }));
            setProductVariations(variations);

            const selectedVariation = variations.find(
              (v) => v.value === data.product_variations_detail[0]?.id
            );
            setSelectedVariation(selectedVariation || null);
          }
        }

        if (data.type_of_offer?.type_of_offer === "Parcel Insert") {
          const variationsRes = await getProductVariationsByProductBrand(data.brand);
          const fetchedVariations = variationsRes.data.map((v) => ({
            value: v.id,
            label: v.product_variation_desc,
            object: v,
          }));
          setAllProductVariations(fetchedVariations);

          const selectedVariations = fetchedVariations.filter((v) =>
            data.product_variations_detail?.some((detail) => detail.id === v.value)
          );
          setSelectedParcelInsertVariations(selectedVariations);
        }
      }

      setSelectedOfferPricings([]);
      setSelectedOfferPricings(
        data.marketing_skus.map((pricing) => ({
          value: pricing.id,
          label: pricing.sku,
          object: pricing,
          pId: pricing.id,
        }))
      );
    } catch (error) {
      console.error("Error fetching marketing data:", error);
    }
  };

  const handleProductChange = async (selectedOption) => {
    setSelectedProduct(selectedOption);
    setSelectedVariation(null);
    try {
      const variationsRes = await getConfirmedProductVariationsByProductId(selectedOption.value);
      setProductVariations(
        variationsRes.data.map((variation) => ({
          value: variation.id,
          label: variation.product_variation_desc,
        }))
      );
      const response = await getNextOfferNumber(selectedOption.value);
      setNextOfferNumber(response.data.next_offer_number);
      setCodeOffer("");
    } catch (error) {
      console.error("Error fetching product variations or next offer number", error);
    }
  };

  const [modalProps, setModalProps] = useState({
    title: "",
    onSubmit: null,
  });

  const handleAddNewTypeOfOffer = async (type_of_offer, type_code) => {
    try {
      const data = { type_of_offer, type_code };
      const response = await createTypeOfOffer(data);
      if (response.status === 201) {
        const newType = {
          value: response.data.id,
          label: response.data.type_of_offer,
          code: response.data.type_code,
        };

        setTypeOfOffers((prevTypeOfOffers) => [...prevTypeOfOffers, newType]);
      }
    } catch (error) {
      console.error("Error adding new Type of Offer:", error);
    }
  };

  const handleAddNewFormOfOffer = async (form_of_offer, form_code) => {
    try {
      const data = {
        form_of_offer,
        form_code,
      };
      const response = await createFormOfOffer(data);
      if (response.status === 201) {
        const newForm = {
          value: response.data.id,
          label: response.data.form_of_offer,
          code: response.data.form_code,
        };
        setFormOfOffers((prevFormOfOffers) => [...prevFormOfOffers, newForm]);
      }
    } catch (error) {
      console.error("Error adding new Form of Offer:", error);
    }
  };

  const handleAddPaymentDetail = async (paymentDetail) => {
    try {
      const response = await createPaymentDetail({ detail: paymentDetail });
      const newPaymentDetail = {
        value: response.data.id,
        label: response.data.detail,
      };
      setPaymentDetails((prevDetails) => [...prevDetails, newPaymentDetail]);
    } catch (error) {
      console.error("Error adding new Payment Detail:", error);
    }
  };

  const [offerModalProps, setOfferModalProps] = useState({
    title: "",
    onSubmit: null,
    fieldLabels: {},
  });

  useEffect(() => {
    if (selectedBrand) {
      const { return_address, payee_names, call_centers } = selectedBrand.object;

      const validReturnAddresses =
        return_address && return_address.some((addr) => addr.trim() !== "")
          ? return_address.map((addr) => ({ value: addr, label: addr }))
          : [];

      setClientReturnAddresses(validReturnAddresses);

      const validPayeeNames =
        payee_names && payee_names.some((name) => name.trim() !== "")
          ? payee_names.map((name) => ({ value: name, label: name }))
          : [];

      setClientPayeeNames(validPayeeNames);

      const validCallCenters = call_centers
        ? call_centers.map((center) => ({
            value: center.id,
            label: center.name,
            object: center,
          }))
        : [];
      setCallCenters(validCallCenters);

      setPhonenumbers([]);
    }
  }, [selectedBrand]);

  const handleCallCenterChange = async (selectedCallCenter) => {
    if (selectedCallCenter && selectedCallCenter.value) {
      const phoneNumbersRes = await fetchPhoneNumbersByCallCenter(selectedCallCenter.value);
      console.log("Fetched phone numbers:", phoneNumbersRes);
      setPhonenumbers(
        phoneNumbersRes.data
          .filter((p) => p.status === "Available" || p.status === codeOffer)
          .map((p) => ({
            value: p.id,
            label: `${p.phone_number} - ${p.status}`,
          }))
      );
    }
  };

  const handleCreateMarketing = async (e) => {
    e.preventDefault();
    e.target.blur();
    if (!isValidMarketing()) {
      return;
    }

    try {
      const prevPhoneNumber = existingMarketingData?.phone_number_details?.id || null;
      const offerDataToCreate = {
        product_variations:
          typeOfOffer?.label.toUpperCase() === "MAILING"
            ? [selectedVariation.value]
            : selectedParcelInsertVariations.map((v) => v.value),
        status_id: selectedStatus?.value,
        type_of_offer_id: typeOfOffer.value,
        form_of_offer_id: formOfOffer.value,
        phone_number: phoneNumber?.value || null,
        offer_description: offer_status_description,
        warranty,
        code_offer: codeOffer,
        gift_visible_in_offer: giftVisible || "No",
        return_address: returnAddress?.label || null,
        payment_details_id: paymentDetail?.value,
        payee_name: payeeName?.value || null,
        marketing_sku: selectedOfferPricings.map((pricing) => pricing.value),
        brand: selectedBrand?.value,
      };

      let response;
      if (marketingId) {
        response = await updateOffer(marketingId, offerDataToCreate);
      } else {
        response = await createOffer(offerDataToCreate);
        setCodeOffer(response.data.code_offer);
        setMarketingId(response.data.id);
      }

      const offerId = response.data.id;
      setMarketingId(offerId);
      navigate(`/marketing/edit-marketing/${offerId}`);

      if (offerId && phoneNumber?.value) {
        await updatePhoneNumberOffer(phoneNumber?.value, offerId, prevPhoneNumber);
      }

      if (marketingFileRef.current) {
        marketingFileRef.current.saveMarketingAllFiles(codeOffer, offerId);
      }

      MySwal.fire({
        icon: "success",
        title: marketingId ? "Marketing Updated Successfully" : "Marketing Created Successfully",
      });

      // if (marketingId) fetchMarketingData();
    } catch (error) {
      console.error("Error creating marketing:", error);
      MySwal.fire({
        icon: "error",
        title: "Unexpected Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    }
  };
  const handleOfferPricingsChange = (selectedOptions) => {
    const lockedOptions = selectedOfferPricings.filter((option) => option.pId);

    const unlockedOptions = selectedOptions.filter((option) => !option.pId);

    const updatedSelection = [...lockedOptions, ...unlockedOptions];

    setSelectedOfferPricings(updatedSelection);
  };

  const [showIndependentSKU, setShowIndependentSKU] = useState(false);
  const [currentPricingId, setCurrentPricingId] = useState(null);

  const handleAddOrEditPricing = (pricingId = null) => {
    setCurrentPricingId(pricingId);
    setShowIndependentSKU(true);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const isValidMarketing = () => {
    if (!selectedStatus) {
      MySwal.fire({
        icon: "warning",
        title: "Missing Offer Status",
        text: "Please select the offer status.",
      });
      scrollToSection("offer-status-section");
      return false;
    }

    if (!selectedProduct && typeOfOffer?.label === "Mailing") {
      MySwal.fire({
        icon: "warning",
        title: "Missing Product",
        text: "Please select a product.",
      });
      scrollToSection("product-selection-section");
      return false;
    }

    if (!selectedVariation && typeOfOffer?.label === "Mailing") {
      MySwal.fire({
        icon: "warning",
        title: "Missing Product Variation",
        text: "Please select a product variation.",
      });
      scrollToSection("product-selection-section");
      return false;
    }

    if (!typeOfOffer) {
      MySwal.fire({
        icon: "warning",
        title: "Missing Type of Offer",
        text: "Please select a type of offer.",
      });
      scrollToSection("offer-codification-section");
      return false;
    }

    if (!formOfOffer) {
      MySwal.fire({
        icon: "warning",
        title: "Missing Form of Offer",
        text: "Please select a form of offer.",
      });
      scrollToSection("offer-codification-section");
      return false;
    }
    if (!paymentDetail) {
      MySwal.fire({
        icon: "warning",
        title: "Missing Payment Detail",
        text: "Please select a payment detail.",
      });

      return false;
    }
    return true;
  };

  const [selectedOfferPricings, setSelectedOfferPricings] = useState([]);

  const [nextOfferNumber, setNextOfferNumber] = useState(null);
  const [startingNumber, setStartingNumber] = useState("");

  useEffect(() => {
    if (typeOfOffer?.label.toUpperCase() === "MAILING") {
      if (selectedProduct && selectedVariation && formOfOffer && !marketingId) {
        const productCode = selectedProduct.object.product_code;
        const typeCode = typeOfOffer.code;
        const formCode = formOfOffer.code;
        const number = nextOfferNumber !== null ? nextOfferNumber : startingNumber;

        setCodeOffer(`${productCode}${typeCode}${formCode}${number || ""}`);
      } else {
        setCodeOffer(existingMarketingData?.code_offer || "");
      }
    } else if (typeOfOffer?.label.toUpperCase() === "PARCEL INSERT") {
      const typeCode = typeOfOffer?.code;
      const formCode = formOfOffer?.code;
      if (!existingMarketingData?.code_offer)
        if (selectedParcelInsertVariations?.length === 1) {
          const productCode = selectedParcelInsertVariations[0]?.object?.product_code;

          setCodeOffer(`${productCode}${typeCode}${formCode}`);
        } else {
          setCodeOffer(`${typeCode}${formCode}` || "");
        }
    }
  }, [
    selectedProduct,
    selectedVariation,
    typeOfOffer,
    formOfOffer,
    nextOfferNumber,
    startingNumber,
    selectedParcelInsertVariations,
    marketingId,
    existingMarketingData?.code_offer,
  ]);

  const handleBrandChange = async (selectedBrand) => {
    setSelectedBrand(selectedBrand);
    setSelectedProduct(null);
    setSelectedVariation(null);
    setSelectedParcelInsertVariations(null);
    if (selectedBrand) {
      try {
        const productsRes = await getProductsByBrand(selectedBrand.value);
        setProducts(
          productsRes.data.map((p) => ({
            value: p.id,
            label: p.name,
            object: p,
          }))
        );
        const productVariationsRes = await getProductVariationsByProductBrand(selectedBrand.value);

        setAllProductVariations(
          productVariationsRes.data.map((p) => ({
            value: p.id,
            label: p.product_variation_desc,
            object: p,
          }))
        );
        setProductVariations([]);
      } catch (error) {
        console.error("Error fetching products or variations:", error);
      }
    } else {
      setProducts([]);
      setAllProductVariations([]);
      setProductVariations([]);
    }
  };

  return (
    <div className="p-2">
      <div>
        {/* Offer Statut Section */}

        <div style={{ display: "flex", flexDirection: "row", gap: "1rem", width: "100%" }}>
          <OfferCodificationSection
            clientBrands={clientBrands}
            handleBrandChange={handleBrandChange}
            selectedBrand={selectedBrand}
            isEditMode={isEditMode}
            marketingId={marketingId}
            typeOfOffers={typeOfOffers}
            formOfOffers={formOfOffers}
            handleAddNewTypeOfOffer={handleAddNewTypeOfOffer}
            handleAddNewFormOfOffer={handleAddNewFormOfOffer}
            setOfferModalProps={setOfferModalProps}
            typeOfOffer={typeOfOffer}
            formOfOffer={formOfOffer}
            setSelectedProduct={setSelectedProduct}
            setSelectedVariation={setSelectedVariation}
            selectedProduct={selectedProduct}
            selectedVariation={selectedVariation}
            products={products}
            productVariations={productVariations}
            handleProductChange={handleProductChange}
            nextOfferNumber={nextOfferNumber}
            startingNumber={startingNumber}
            setStartingNumber={setStartingNumber}
            codeOffer={codeOffer}
            setCodeOffer={setCodeOffer}
            setTypeOfOffer={setTypeOfOffer}
            setFormOfOffer={setFormOfOffer}
            setSelectedParcelInsertVariations={setSelectedParcelInsertVariations}
            selectedParcelInsertVariations={selectedParcelInsertVariations}
            allProductVariations={allProductVariations}
          />
          <div style={{ display: "flex", width: "50%" }}>
            <OfferStatusSection
              statuts={statuts}
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              offer_status_description={offer_status_description}
              setOfferStatusDescription={setOfferStatusDescription}
            />
          </div>
        </div>

        <form style={{ marginTop: 16 }}>
          <OfferSpecification
            clientReturnAddresses={clientReturnAddresses}
            returnAddress={returnAddress}
            setReturnAddress={setReturnAddress}
            clientPayeeNames={clientPayeeNames}
            payeeName={payeeName}
            setPayeeName={setPayeeName}
            callCenters={callCenters}
            callCenter={callCenter}
            handleCallCenterChange={handleCallCenterChange}
            phoneNumbers={phoneNumbers}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            paymentDetails={paymentDetails}
            paymentDetail={paymentDetail}
            setPaymentDetail={setPaymentDetail}
            warranty={warranty}
            setWarranty={setWarranty}
            giftVisible={giftVisible}
            setGiftVisible={setGiftVisible}
            setModalProps={setModalProps}
            handleAddPaymentDetail={handleAddPaymentDetail}
            setCallCenter={setCallCenter}
          />

          <>
            <MarketingFilesSection
              ref={marketingFileRef}
              code_offer={codeOffer}
              offer_id={marketingId}
              brand_id={selectedBrand?.value}></MarketingFilesSection>

            <MarketingSKUTable
              selectedOfferPricings={selectedOfferPricings}
              handleAddOrEditPricing={handleAddOrEditPricing}
              fetchMarketingData={fetchMarketingData}
              offerPricingsOptions={offerPricingsOptions}
              setSelectedOfferPricings={setSelectedOfferPricings}
              scrollToSection={scrollToSection}
              handleOfferPricingsChange={handleOfferPricingsChange}
              setShowIndependentSKU={setShowIndependentSKU}
              setCurrentPricingId={setCurrentPricingId}
            />
            <div className="d-flex justify-content-end mt-3">
              <button
                hidden={marketingId | ""}
                className="btn btn-submit"
                onClick={(event) => {
                  handleCreateMarketing(event, false);
                }}>
                Create Marketing
              </button>
            </div>
          </>

          <div className="d-flex justify-content-end mt-3">
            <button
              className="btn btn-submit"
              hidden={!marketingId | ""}
              onClick={(event) => {
                handleCreateMarketing(event, false);
              }}>
              {"Update Marketing"}
            </button>
          </div>
        </form>
      </div>
      <AddCategory {...modalProps}></AddCategory>
      <AddTwoFieldsModal {...offerModalProps}></AddTwoFieldsModal>
      {showIndependentSKU && (
        <IndependentSKU
          isVisible={showIndependentSKU}
          skuId={currentPricingId}
          offerId={marketingId}
          onClose={() => {
            setShowIndependentSKU(false);
            if (marketingId) fetchMarketingData();
          }}
          onResize={() => {
            // intentionally empty
          }}
        />
      )}
    </div>
  );
};
export default EditMarketing;
